import { render, staticRenderFns } from "./textarea-len.vue?vue&type=template&id=1c1cc162&scoped=true"
import script from "./textarea-len.vue?vue&type=script&lang=js"
export * from "./textarea-len.vue?vue&type=script&lang=js"
import style0 from "./textarea-len.vue?vue&type=style&index=0&id=1c1cc162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1cc162",
  null
  
)

export default component.exports